import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";

import { NgxMaskDirective, provideNgxMask } from "ngx-mask";
import { Firm360SharedModule } from "../shared/shared.module";
import { accountState } from "./account.route";
import { ActivateComponent } from "./activate/activate.component";
import { SetupTwoFactorModalComponent } from "./components/setup-two-factor-modal/setup-two-factor-modal.component";
import { ImpersonateComponent } from "./login/impersonate.component";
import { LoginComponent } from "./login/login.component";
import { OAuthCallbackComponent } from "./login/oauth-callback.component";
import { VerifyTwoFactorComponent } from "./login/verify-two-factor.component";

import { PasswordStrengthBarComponent } from "./password/password-strength-bar.component";
import { PasswordComponent } from "./password/password.component";
import { PasswordResetFinishComponent } from "./password-reset/finish/password-reset-finish.component";
import { PasswordResetInitComponent } from "./password-reset/init/password-reset-init.component";
import { SettingsComponent } from "./settings/settings.component";

@NgModule({
    imports: [
        Firm360SharedModule,
        RouterModule.forChild(accountState),
        NgxMaskDirective,
    ],
    declarations: [
        LoginComponent,
        ImpersonateComponent,
        OAuthCallbackComponent,
        VerifyTwoFactorComponent,
        ActivateComponent,
        PasswordComponent,
        PasswordStrengthBarComponent,
        PasswordResetInitComponent,
        PasswordResetFinishComponent,
        SettingsComponent,
        SetupTwoFactorModalComponent,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    providers: [provideNgxMask()],
})
export class Firm360AccountModule {}
